module.exports = __webpack_public_path__ + "static/media/hearclearpro-earwax-guard-5.ee999d90.png";